"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Speaker(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.211v3.561l6.969 4.099a.684.684 0 001.031-.59V1.702a.685.685 0 00-1.031-.59L4 5.211zm-1-.572L10.462.25A1.684 1.684 0 0113 1.702v10.579a1.684 1.684 0 01-2.538 1.452L3 9.344V4.639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6h2a.5.5 0 010 1h-2a.5.5 0 010-1zM14.06 9.353l1.414 1.414a.5.5 0 01-.707.707l-1.414-1.414a.5.5 0 01.707-.707zM13.353 2.768l1.414-1.414a.5.5 0 01.707.707L14.06 3.475a.5.5 0 01-.707-.707zM3 9.406L2 9v5.469C2 15.3 2.75 16 3.5 16S5 15.3 5 14.469v-4.25l-.927-.376a1 1 0 00-.073.376v4.25c0 .255-.278.531-.5.531s-.5-.276-.5-.531V9.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5v4h2V5H1zM.842 4H4v6H.842A.842.842 0 010 9.158V4.842C0 4.377.377 4 .842 4z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Speaker);
var _default = ForwardRef;
exports["default"] = _default;